// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b4b5cd75","437":"85d53866","506":"5f0cb9b7","632":"bc3a59f4"}[chunkId] + ".chunk.js";
};